import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

import StatusCardTemplate from './StatusCardTemplate';

export default function InProgressStatusCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.statusCards.inProgress',
  });

  return (
    <StatusCardTemplate
      icon={<Spinner variant="primary" size="sm" />}
      iconBackgroundColor="primary-100"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="status-in-progress"
    />
  );
}
